import { render } from "./Reviews.vue?vue&type=template&id=46ae01d9"
import script from "./Reviews.vue?vue&type=script&lang=js"
export * from "./Reviews.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/BinaryFlow/components/Product/Reviews.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "46ae01d9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('46ae01d9', __exports__)) {
    api.reload('46ae01d9', __exports__)
  }
  
  module.hot.accept("./Reviews.vue?vue&type=template&id=46ae01d9", () => {
    api.rerender('46ae01d9', render)
  })

}


export default __exports__